import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import MainFont from 'ui/typography/mainFont';
import {
  DetailsTitle,
  DetailsWrapper,
  ExternalGridContainer,
  GridContainer,
  ButtonSave
} from './style';
import { FormInput, FormTextArea, Icon } from 'ui/atoms';

import { leadDetailFieldsReadonly, isReadOnly, brandsVehicle } from 'const';
import phonePrefixesSalesforce from 'utils/phonePrefixesSalesforce';
import { UPDATE_LEAD_DETAIL } from 'redux/sagas/actions/leadDetail';
import theme from 'ui/theme';
import spinnerIconBlue from 'ui/assets/img/spinner-icon-blue.png';
import { SpinnerIcon } from 'ui/atoms/Table/style';

const DetailSection = ({
  leadDetailData,
  updateLeadDetail,
  leadStatus,
  role,
  userEmail,
  creatorEmail,
  leadType,
  isReadonlySection,
  isSaveEnabled,
  isLoadingUpdate,
  updatingSection
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState('');
  const [originalValues, setOriginalValues] = useState({});
  const [updatedValues, setUpdatedValues] = useState({});
  const [showSave, setShowSave] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (leadDetailData?.innerData) {
      let data = {};
      const { innerData } = leadDetailData;
      if (innerData && Array.isArray(innerData)) {
        innerData.forEach(item =>
          item?.forEach(innerItem => {
            if (innerItem.labelFromBe) {
              data[innerItem.labelFromBe] = innerItem.value;
            }
          })
        );
      }
      setUpdatedValues(data);
      setOriginalValues(data);
    }
  }, [leadDetailData]);

  useEffect(() => {
    if (
      updatedValues &&
      originalValues &&
      Object.keys(updatedValues).length !== 0 &&
      Object.getPrototypeOf(updatedValues) === Object.prototype &&
      JSON.stringify(updatedValues) !== JSON.stringify(originalValues)
    ) {
      setShowSave(true);
      isSaveEnabled(true);
    } else {
      setShowSave(false);
      isSaveEnabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedValues]);

  const isDropdown = label => {
    if (
      label === 'prefix' ||
      label === 'prefix_secondary_phone' ||
      label === 'product_preferences_placeholder' ||
      label === 'brand'
    ) {
      return 'dropdown';
    }
  };

  const loadArrayData = label => {
    if (isDropdown(label)) {
      return label === 'brand' ? brandsVehicle() : phonePrefixesSalesforce;
    }
  };

  const isAdditionalNote = title => title === 'additional_note';

  const areDataReadyToBeUpdated = () => {
    return (
      (updatedValues &&
        originalValues &&
        Object.getPrototypeOf(updatedValues) === Object.prototype &&
        Object.getPrototypeOf(originalValues) === Object.prototype &&
        Object.keys(updatedValues).length ===
          Object.keys(originalValues).length) ||
      (isReadonlySection && originalValues)
    );
  };

  return (
    <DetailsWrapper>
      <DetailsTitle>
        <MainFont type="4" configuration={{ fontSize: 16, lineHeight: '1.5' }}>
          {t(leadDetailData.title)}
        </MainFont>
        {!isReadonlySection && showSave ? (
          isLoadingUpdate && updatingSection === leadDetailData.title ? (
            <ButtonSave
              onClick={e => {
                e.preventDefault();
              }}
            >
              <SpinnerIcon
                icon={spinnerIconBlue}
                marginRight={11}
                customSize={16}
              />
              {t('loading')}
            </ButtonSave>
          ) : (
            <ButtonSave
              disabled={error}
              onClick={() => {
                updateLeadDetail({
                  dataSectionTitle: leadDetailData.title,
                  data: updatedValues
                });
              }}
            >
              <Icon
                type="icon-save"
                size={16}
                color={
                  error ? theme().colors.fadedGray : theme().colors.mainBlue
                }
              />
              {t('save_updates')}
            </ButtonSave>
          )
        ) : null}
      </DetailsTitle>
      <ExternalGridContainer
        isNoteSection={isAdditionalNote(leadDetailData.title)}
      >
        {areDataReadyToBeUpdated() &&
          leadDetailData?.innerData?.map((singleRow, key) => {
            if (singleRow && Array.isArray(singleRow)) {
              return (
                <GridContainer
                  isNoteSection={isAdditionalNote(leadDetailData.title)}
                  key={key}
                >
                  {singleRow?.map((element, i) => {
                    return (
                      <React.Fragment key={i}>
                        {isAdditionalNote(leadDetailData.title) ? (
                          <FormTextArea
                            type={isDropdown(element.label)}
                            label={t(element.label)}
                            labelFromBe={element.labelFromBe}
                            readonly={
                              isReadOnly(
                                true,
                                role,
                                creatorEmail,
                                userEmail,
                                leadStatus
                              ) ||
                              leadDetailFieldsReadonly[leadType].includes(
                                element.label
                              ) ||
                              leadDetailData.title === 'lead_created_by'
                            }
                            key={key}
                            value={element?.value || null}
                            onFocus={() => setSelected(t(element.label))}
                            isEditing={
                              !isReadOnly(
                                true,
                                role,
                                creatorEmail,
                                userEmail,
                                leadStatus
                              )
                                ? selected === t(element.label)
                                : null
                            }
                            visible
                            isLeadDetail
                            variant="leadDetail"
                            maxLength={255}
                            onChange={e => {
                              const obj = { ...updatedValues };
                              obj[element.labelFromBe] = e;
                              setUpdatedValues({ ...obj });
                            }}
                          />
                        ) : (
                          <div
                            onMouseMove={() => setSelected(t(element.label))}
                            onMouseLeave={() => {
                              setSelected('');
                            }}
                          >
                            <FormInput
                              type={isDropdown(element.label)}
                              label={element.label}
                              labelFromBe={element.labelFromBe}
                              readonly={
                                isReadOnly(
                                  false,
                                  role,
                                  creatorEmail,
                                  userEmail,
                                  leadStatus
                                ) ||
                                leadDetailFieldsReadonly[leadType].includes(
                                  element.label
                                ) ||
                                leadDetailData.title === 'lead_created_by'
                              }
                              key={key}
                              value={element.value}
                              isEditing={
                                !isReadOnly(
                                  false,
                                  role,
                                  creatorEmail,
                                  userEmail,
                                  leadStatus
                                )
                                  ? selected === t(element.label)
                                  : null
                              }
                              visible
                              isLeadDetail
                              arrayData={loadArrayData(element.label)}
                              onChange={e => {
                                const obj = { ...updatedValues };
                                obj[element.labelFromBe] = e?.value
                                  ? e.value.split(' ')?.[0]
                                  : e;
                                setUpdatedValues({ ...obj });
                              }}
                              setError={value => setError(value)}
                            />
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </GridContainer>
              );
            }
            return <></>;
          })}
      </ExternalGridContainer>
    </DetailsWrapper>
  );
};

DetailSection.propTypes = {
  leadDetailData: PropTypes.object,
  leadStatus: PropTypes.string,
  role: PropTypes.string,
  userEmail: PropTypes.string,
  creatorEmail: PropTypes.string,
  updateLeadDetail: PropTypes.func,
  isReadonlySection: PropTypes.bool,
  isSaveEnabled: PropTypes.func,
  isLoadingUpdate: PropTypes.bool,
  updatingSection: PropTypes.string
};

export default connect(
  state => ({
    role: state?.authentication?.accountInfo?.role,
    userEmail: state?.authentication?.accountInfo?.email,
    isLoadingUpdate: state?.leadDetail?.isLoadingUpdate,
    updatingSection: state?.leadDetail?.updatingSection
  }),
  dispatch => ({
    pushUrl: url => dispatch(push(url)),
    updateLeadDetail: ({ dataSectionTitle, data }) =>
      dispatch({
        type: UPDATE_LEAD_DETAIL._REQUEST,
        payload: { dataSectionTitle, data }
      })
  })
)(DetailSection);
